import React from 'react';
import { Toaster } from 'react-hot-toast';
import LoadingTables from '../../../components/global/LoadingTables';
import Nav from '../../../components/specific/Navigation';
import PageHeading from '../../../components/global/PageHeading';
import { ButtonTable } from '../../../components/global/Styles/buttons';
import { TitlesTables } from '../../../components/global/Styles/titles';
import TableConciliaciones from '../../../components/specific/Conciliacion/Table';
import SubirConciliacion from '../../../components/specific/Conciliacion/Modales/SubirConciliacion';
import DetallesConciliacion from '../../../components/specific/Conciliacion/Modales/DetallesConciliacion';
import TakeoffTab from '../../../components/specific/Conciliacion/Takeoff/TakeoffTab';

const selectedTabClass =
  'relative block border-b-2 border-l border-r border-t-2 bg-gray-100 border-gray-200 p-3 font-medium text-gray-800 cursor-pointer rounded-t-md';
const noSelectedTabClass =
  'border-l border-b-2 border-r border-t-2 border-gray-200 block p-3 font-medium text-gray-500 hover:text-gray-800 cursor-pointer rounded-t-md';
const checkIsTabSelected = (key, selected) => (key === selected ? selectedTabClass : noSelectedTabClass);

const ViewConciliacion = (props) => {
  const { uploadFile, setUploadFile } = props.modal;
  const { loadingTables, handleRefresh } = props.actions;
  const { selectedTab = 1, handleTabClick = () => {} } = props.tabs || {};
  const { data: takeoffData = {}, actions: takeoffActions = {}, pager: takeoffPager = {} } = props.takeoff || {};
  const {
    detailsModal,
    detailsLoading,
    selectedProcess,
    detailFilter,
    detailRows,
    detailCounts,
    handleDetailFilterChange,
    handleCloseDetails,
    handleRefreshDetails,
  } = props.details;

  return (
    <div className="flex max-h-screen min-h-screen flex-col overflow-hidden ">
      <Nav />
      <Toaster
        toastOptions={{
          className: 'w-1/2',
        }}
      />

      <div className="flex flex-grow flex-col overflow-hidden ">
        <div className="m-2 flex flex-grow flex-col overflow-hidden   ">
          <div className="flex">
            <TitlesTables>CONCILIACIONES</TitlesTables>
            <div className="flex-auto"></div>
          </div>

          <ul className="flex text-center">
            <li className="flex-1">
              <div></div>
            </li>
            <li className="flex-1">
              <div></div>
            </li>
            <li className="flex-1">
              <div></div>
            </li>
            <li className="flex-1">
              <div
                className={checkIsTabSelected(1, selectedTab)}
                onClick={() => handleTabClick(1)}>
                Importaciones
              </div>
            </li>
            <li className="flex-1">
              <div
                className={checkIsTabSelected(2, selectedTab)}
                onClick={() => handleTabClick(2)}>
                Takeoff
              </div>
            </li>
          </ul>

          <div className="flex flex-grow flex-col overflow-hidden">
            {selectedTab === 1 && (
              <>
                <div className="flex items-center justify-end py-2">
                  <div className="flex space-x-2">
                    <ButtonTable onClick={() => handleRefresh()}>Refrescar</ButtonTable>
                    <ButtonTable onClick={() => setUploadFile(true)}>Importar</ButtonTable>
                  </div>
                </div>
                {loadingTables && <LoadingTables />}
                <div className="flex-grow overflow-y-auto">
                  <TableConciliaciones
                    actions={props.actions}
                    data={{ loadingTables }}
                  />
                </div>
              </>
            )}

            {selectedTab === 2 && (
              <>
                <TakeoffTab
                  data={takeoffData}
                  actions={takeoffActions}
                  pager={takeoffPager}
                />
              </>
            )}
          </div>
        </div>
      </div>

      {uploadFile && selectedTab === 1 ? <SubirConciliacion actions={{ setUploadFile, handleRefresh }} /> : null}
      {detailsModal && selectedTab === 1 ? (
        <DetallesConciliacion
          data={{
            detailsLoading,
            selectedProcess,
            detailFilter,
            detailRows,
            detailCounts,
          }}
          actions={{
            handleDetailFilterChange,
            handleCloseDetails,
            handleRefreshDetails,
          }}
        />
      ) : null}
    </div>
  );
};

export default ViewConciliacion;
